var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgShipping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "-424 226 110 110"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-415.9 278.1c0-.7.6-1.3 1.3-1.3h15.9c.7 0 1.3.6 1.3 1.3 0 .7-.6 1.3-1.3 1.3h-15.9c-.7.1-1.3-.5-1.3-1.3zm20.7 11.4h-14.6c-.7 0-1.3-.6-1.3-1.3s.6-1.3 1.3-1.3h14.6c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3zm1.3-20.1h-11.9c-.7 0-1.3-.6-1.3-1.3 0-.7.6-1.3 1.3-1.3h11.9c.7 0 1.3.6 1.3 1.3s-.6 1.3-1.3 1.3zm15.4 29.7c-3.3 0-5.9-2.6-5.9-5.9s2.6-5.9 5.9-5.9 5.9 2.6 5.9 5.9-2.7 5.9-5.9 5.9zm38.7 0c-3.3 0-5.9-2.6-5.9-5.9s2.6-5.9 5.9-5.9 5.9 2.6 5.9 5.9-2.7 5.9-5.9 5.9zm12.3-5.6h-4.5v-.3c0-4.3-3.5-7.9-7.9-7.9s-7.9 3.5-7.9 7.9v.3h-23v-.3c0-4.3-3.5-7.9-7.9-7.9-4.3 0-7.9 3.5-7.9 7.9v.3h-1.8c-1.1 0-2-.9-2-2v-26.8c0-1.1.9-2 2-2h48.5c1 0 1.8.7 2 1.7l1.8 11.3 8.8 1.6c.9.2 1.6 1 1.6 2v12.3c.2 1-.7 1.9-1.8 1.9zm-14-27.8h-7.4c-.4 0-.8.4-.8.8v8.2c0 .4.4.8.8.8h8.7c.4-.1.7-.5.7-.9l-1.2-8.2c0-.4-.4-.7-.8-.7z",
    fill: "#fff"
  })));
}

export default SvgShipping;